function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Teach_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.816 24.362a.762.762 0 01-.716-1.022l3.263-8.975a.762.762 0 011.432.52l-3.263 8.975a.762.762 0 01-.716.502zM21.972 24.362a.762.762 0 01-.715-.5l-3.296-8.974a.762.762 0 011.43-.525l3.296 8.974a.762.762 0 01-.715 1.025z",
  fill: "#B86E4D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.605 1.625H12.182A2.393 2.393 0 009.79 4.018v8.976a2.393 2.393 0 002.393 2.393h11.423a2.393 2.393 0 002.393-2.394V4.018a2.393 2.393 0 00-2.393-2.393z",
  fill: "#FFD6AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.159 6.466a3.318 3.318 0 11-6.636 0 3.318 3.318 0 016.636 0z",
  fill: "#FFCFBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.25 14.491a.762.762 0 01-.341-1.021l2.04-4.08a.762.762 0 011.362.681l-2.04 4.08a.762.762 0 01-1.022.34z",
  fill: "#FFAD05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.975 6.004h-8.159a.762.762 0 010-1.524h8.16a.762.762 0 010 1.524zM21.976 9.268H18.56a.762.762 0 110-1.524h3.417a.762.762 0 110 1.524zM21.976 12.531H18.56a.762.762 0 010-1.523h3.417a.762.762 0 110 1.523z",
  fill: "#B86E4D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.289 24.362H2.393a.762.762 0 01-.761-.762v-4.258A2.397 2.397 0 010 17.072v-2.447c0-1.295.504-2.51 1.42-3.424A4.866 4.866 0 014.84 9.784h.673c1.337 0 2.12.49 3.217 1.035l3.678 1.83a1.982 1.982 0 01.99 2.42 2.082 2.082 0 01-1.182 1.257 2.094 2.094 0 01-1.728-.065l-2.438-1.22V23.6c0 .42-.342.762-.762.762z",
  fill: "#F29B73"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Teach_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h26v26H0z"
})));

function SvgTeach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgTeach;